import { FilterState } from "src/pages/ManageEvaluation/QuestionsPanel/Filters/types";

export const INITIAL_FILTER_STATE: FilterState = {
  domains: {},
  stages: {}
};
